export default "/static/build/question-card-stack.png";